module.exports = __webpack_public_path__ + "static/media/invitation-letter copy.a7a67d31.png";